import {REQUEST_ADD_CUSTOMER_ORDER_SUCCESS} from "../../../constant/transaction/CustomerOrderConstant";

const initialState = {
    customerOrder: {
        data: [],
    },
};


export const customerOrderReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ADD_CUSTOMER_ORDER_SUCCESS:
            return {
                ...state,
                customerOrder: {
                    data: payload,
                },
            };
        default:
            return state;
    }
}
